// extracted by mini-css-extract-plugin
module.exports = {"question_banner":"Banner_question_banner__ppEQL"};